import React, { useState } from "react";
import DatePicker from "react-datepicker";
import CustomDatePickerInput from "./CustomDatePickerInput/CustomDatePickerInput";
import { localeDate } from "utils/helper";
import "./CustomDatePicker.scss";

export const CustomDatePicker = ({
    onChange,
    name,
    value,
    minDate,
    maxDate,
    startDate,
    endDate,
    hasError,
    placeholder,
    hasIcon,
    otherClassNames,
    selectsRange,
}) => {
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();

    const handleChange = (date) => {
        if (selectsRange) {
            onChange?.(date);
            setFromDate(date[0]);
            setToDate(date[1]);
        } else {
            let dateString = localeDate(date);
            onChange?.(dateString);
        }
    };

    return (
        <div className={`form-group`}>
            <DatePicker
                onChange={(date) => {
                    handleChange(date);
                }}
                h
                className={`form-control ${
                    otherClassNames ? otherClassNames : ""
                } ${hasError ? `date__picker__error__border` : ``}`}
                name={name}
                value={value}
                popperPlacement='top-start'
                minDate={minDate}
                maxDate={maxDate}
                selectsRange={true}
                startDate={fromDate || startDate}
                endDate={toDate || endDate}
                placeholderText={placeholder}
                // dateFormat="YYYY-MM-DD"
                customInput={
                    hasIcon && (
                        <CustomDatePickerInput
                            hasError={hasError}
                            otherClassNames={otherClassNames}
                        />
                    )
                }
            />
        </div>
    );
};
